import React, { useState } from 'react';
import { FC } from 'react';
import {
  useFloating,
  useHover,
  useClick,
  useDismiss,
  useInteractions,
  offset,
  flip,
  shift,
  FloatingPortal,
} from '@floating-ui/react';

const Tooltip: FC<{ children?: React.ReactNode, className?: string }> = ({ children, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'bottom-start',
    middleware: [
      offset(8),
      flip({ fallbackPlacements: ['top-start', 'right', 'left'] }),
      shift({ padding: 8 }),
    ],
  });

  const hover = useHover(context, {
    delay: {
      open: 100,
      close: 300,
    },
  });

  const click = useClick(context);
  const dismiss = useDismiss(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    hover,
    click,
    dismiss,
  ]);

  return (
    <>
      <div
        ref={refs.setReference}
        {...getReferenceProps()}
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={className}
      >
        <div className="tooltip__trigger">
          <span className="tooltip__trigger_text">i</span>
        </div>
      </div>
      {isOpen && (
        <FloatingPortal>
          <div
            ref={refs.setFloating}
            style={{ ...floatingStyles, zIndex: 1001 }}
            {...getFloatingProps()}
            className="tooltip"
          >
            <div className="tooltip-content">{children}</div>
          </div>
        </FloatingPortal>
      )}
    </>
  );
};

export default Tooltip;